import { React, useEffect, useState } from "react";
import "../../styles/desktop/AlarmeModal.css";
import LegendaCaixadagua from "./LegendaCaixaDagua/legendaCaixaDagua";
import Alarmes from "./AlarmeObjeto/Alarmes";
import { getAlarmes } from "../../API/getAlarmes";

const GroupLightComponent = () => {
  const [alarmesStatus, setAlarmesStatus] = useState( [
    {
      dados: ["OFF", "OFF", "OFF","OFF", "OFF", "OFF","OFF", "OFF"],
    },
    {
      dados: ["OFF", "OFF", "OFF","OFF", "OFF", "OFF","OFF", "OFF"],
    },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAlarmes();
      setAlarmesStatus(data);
      console.log("Alarmes", data);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8200);
  
    return () => clearInterval(intervalId);
  }, []);
//teste
  return (
    <>
      <div className="CampoAlarme">
        <h1 className="tituloCampo4">Alarmes</h1>
        <div className="campoLegendaCaixadagua">
          <LegendaCaixadagua alarmesStatus={alarmesStatus}/>
        </div>
        <div className="campoAlarmes">
          <Alarmes alarmesStatus={alarmesStatus} />
        </div>
      </div>
    </>
  );
};

export default GroupLightComponent;